export default "__VITE_ASSET__7be93402__"